import NotFoundSvg from '@/assets/404.svg?react';
import { Button, Typography } from '@propify/admin-components';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

const NoFoundPage: FC = () => {
  const navigate = useNavigate();

  const handleBackHome = () => navigate('/');

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '24px' }}
    >
      <NotFoundSvg />
      <div style={{ flexDirection: 'column', alignItems: 'center', marginTop: '24px' }}>
        <Typography variant="h3" style={{ textAlign: 'center', marginBottom: '12px' }}>
          404
        </Typography>
        <Typography variant="body" style={{ textAlign: 'center', marginBottom: '32px' }}>
          Sorry, the page you visited does not exist.
        </Typography>
        <div style={{ textAlign: 'center' }}>
          <Button onClick={handleBackHome}>Back Home</Button>
        </div>
      </div>
    </div>
  );
};

export default NoFoundPage;
